"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var react_1 = __importDefault(require("react"));
var Loader_module_scss_1 = __importDefault(require("./Loader.module.scss"));
var react_loader_spinner_1 = require("react-loader-spinner");
var Loader = function (_a) {
    var extraClass = _a.extraClass;
    return (react_1.default.createElement("div", { className: "".concat(Loader_module_scss_1.default.loader_wrapper, " ").concat(extraClass) },
        react_1.default.createElement(react_loader_spinner_1.RotatingLines, { visible: true, width: "96", strokeWidth: "5", animationDuration: "0.75", ariaLabel: "rotating-lines-loading" })));
};
exports.Loader = Loader;
